import { render, staticRenderFns } from "./PushServiceAdmin.vue?vue&type=template&id=50c24af5&scoped=true&"
import script from "./PushServiceAdmin.vue?vue&type=script&lang=js&"
export * from "./PushServiceAdmin.vue?vue&type=script&lang=js&"
import style0 from "./PushServiceAdmin.vue?vue&type=style&index=0&id=50c24af5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c24af5",
  null
  
)

export default component.exports